import { ProductSearchMaterial } from '../../types';

// TODO: move this helper to shared helpers folder
export const getAnalyticsItemCategoriesByTaxonomy = (
  taxonomy: string[] = [],
) => {
  const itemCategory: string[] = [];
  const itemCategory2: string[] = [];
  const itemCategory3: string[] = [];

  taxonomy.forEach((value) => {
    const splittedTaxonomy = value.split('>') ?? [];
    if (splittedTaxonomy[0] && !itemCategory.includes(splittedTaxonomy[0])) {
      itemCategory.push(splittedTaxonomy[0]);
    }
    if (splittedTaxonomy[1] && !itemCategory2.includes(splittedTaxonomy[1])) {
      itemCategory2.push(splittedTaxonomy[1]);
    }
    if (splittedTaxonomy[2] && !itemCategory3.includes(splittedTaxonomy[2])) {
      itemCategory3.push(splittedTaxonomy[2]);
    }
  });
  return {
    item_category: itemCategory.join(', '),
    item_category2: itemCategory2.join(', '),
    item_category3: itemCategory3.join(', '),
  };
};

export const mapProductToAnalyticsEcommerceItem = (params: {
  product: ProductSearchMaterial;
  itemListId?: string;
  itemListName?: string;
  index?: number;
}) => {
  const { product, itemListId, itemListName, index } = params;

  const colorway = product.ssFacetColorFilter?.find(
    (color) => color.image_url === product.thumbnailImageUrl?.split('?')?.[0],
  );
  const itemColor = colorway != null ? colorway?.color_name : null;
  const finishesColor = product?.configData?.color;

  return {
    item_id: product.sku,
    item_name: product.name,
    item_brand: product.manufacturer,
    ...getAnalyticsItemCategoriesByTaxonomy(product.taxonomy),
    index: product.gridIndex ?? product.index ?? index,
    price: 0,
    quantity: 1,
    item_list_id: product?.isDigital ? 'digital_sampling' : itemListId,
    item_list_name: product?.isDigital ? 'Digital sampling' : itemListName,
    item_variant: finishesColor ?? itemColor ?? '',
  };
};

/**
 * Build URL params for Analytics tracking on PDP based on the search list
 * @param params
 * @return string
 */
export const buildAnalyticsParamsToPDP = (params: {
  product: any;
  itemListId?: string;
  itemListName?: string;
  index?: number;
}) => {
  const { product, itemListId, itemListName, index } = params;

  const urlParams = [];
  itemListId && urlParams.push(`itemListId=${itemListId}`);
  itemListName && urlParams.push(`itemListName=${itemListName}`);
  urlParams.push(`index=${product?.gridIndex ?? product?.index ?? index}`);

  return urlParams.join('&');
};
